import { render, staticRenderFns } from "./CargoesComposePanel.vue?vue&type=template&id=ecf33f82&"
import script from "./CargoesComposePanel.vue?vue&type=script&lang=js&"
export * from "./CargoesComposePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports